import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule} from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { BehaviorSubject } from 'rxjs';
import { PropertySelectDialogComponent } from './property-select-dialog/property-select-dialog.component';
import { Property } from '../../../../properties/models/Property';
import { PropertiesDetailComponent } from '../../../../properties/property-detail/properties-detail.component';

@Component({
  selector: 'app-property-step',
  templateUrl: './property-step.component.html',
  styleUrls: ['./property-step.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    PropertiesDetailComponent
  ]
})
export class PropertyStepComponent implements OnInit {

  @Input('existingProperty') existingProperty?: Property;
  @Input('organizationId') organizationId!: any;
  @Output() onPropertySelected = new EventEmitter<number>();

  loading = new BehaviorSubject<boolean>(false);
  panelOpen = false;
  propertyId?: number;

  constructor(private readonly dialog: MatDialog) { }

  ngOnInit(): void {
    if (this.existingProperty) {
      this.propertyId = this.existingProperty.property_id;
    }
  }

  onShowPropertySearchClick() {
    const cachedPropertyId = this.propertyId;
    this.propertyId = undefined;

    const dialogRef = this.dialog.open(PropertySelectDialogComponent, {
      width: '80%',
      maxHeight: '90vh',
      data: this.organizationId
    });
    dialogRef.afterClosed().subscribe(propertyId => {
      if (propertyId) {
        this.updateSelectedPropertyId(propertyId);
      } else {
        this.propertyId = cachedPropertyId;
      }
    });
  }

  private updateSelectedPropertyId(propertyId?: number) {
    this.propertyId = propertyId;
    this.onPropertySelected.emit(propertyId);
  }
}